import { SET_INITIALISED, SET_DATA, SET_BASEPATH, SET_BASE_BREADCRUMB, ADD_TO_HISTORY, SET_ERROR } from './types';

export const setInitialised = () => ({
  type: SET_INITIALISED,
});

export const setData = payload => ({
  type: SET_DATA,
  payload,
});

export const setBasepath = payload => ({
  type: SET_BASEPATH,
  payload,
});

export const setBaseBreadcrumb = payload => ({
  type: SET_BASE_BREADCRUMB,
  payload,
});

export const addToHistory = payload => ({
  type: ADD_TO_HISTORY,
  payload,
});

export const setError = payload => ({
  type: SET_ERROR,
  payload,
});
